module.exports = __webpack_public_path__ + "static/avatar-9b69586cbf549ffa759184dcf2cec919.jpg";